<template>
  <div class="saas-listing-page">
    <div class="saas-page-head">
      <div class="saas-rounded-shape saas-rounded-shape__vertical-left-1"></div>
      <div
        class="saas-rounded-shape saas-rounded-shape--white saas-rounded-shape__vertical-left-2"
      >
        <img
          class="saas-rounded-shape-icon saas-rounded-shape-icon--grayscale"
          src="@saas/assets/images/gitlab-icon.svg"
        />
      </div>
      <div class="saas-rounded-shape saas-rounded-shape__vertical-left-3"></div>
      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-4"
      ></div>

      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-5"
      ></div>

      <div
        class="saas-rounded-shape saas-rounded-shape--white saas-rounded-shape__vertical-right-6"
      >
        <img
          class="saas-rounded-shape-icon"
          src="@saas/assets/images/zendesk-icon.svg"
        />
      </div>

      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-7"
      ></div>

      <h1 class="saas-page-head__title" v-html="formattedTitle"></h1>
      <p class="saas-page-head__description">
        {{ page.intro_description }}
      </p>
      <TextSearchInput
        v-model="searchQuery"
        placeholder="Search integrations..."
      ></TextSearchInput>
    </div>
    <div ref="body" class="saas-listing-page__body">
      <div class="saas-listing-page__sidebar">
        <div class="saas-listing-page__sidebar-sticky">
          <template v-for="category in Object.keys(categories)">
            <div
              :key="category + '__1'"
              class="saas-listing-page__sidebar-small-title"
            >
              {{ category }}
            </div>
            <ul :key="category + '__2'" class="saas-listing-page__categories">
              <li
                v-for="type in Object.keys(categories[category])"
                :key="type"
                class="saas-listing-page__categories-item"
              >
                <Checkbox
                  :checked="categories[category][type]"
                  class="saas-listing-page__categories-checkbox"
                  @input="setCategoryType(category, type, $event)"
                  >{{ type }}</Checkbox
                >
              </li>
            </ul>
          </template>
        </div>
      </div>

      <div class="saas-integration-cards">
        <IntegrationCard
          v-for="integration in filteredIntegrations"
          :key="integration.id"
          :integration="integration.value"
        ></IntegrationCard>
      </div>
    </div>
    <FooterJoin></FooterJoin>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
import { clone } from '@baserow/modules/core/utils/object'
import { escapeRegExp } from '@baserow/modules/core/utils/string'
import cmsPage from '@saas/mixins/cmsPage'
import TextSearchInput from '@saas/components/TextSearchInput'
import IntegrationCard from '@saas/components/IntegrationCard'
import FooterJoin from '@saas/components/footer/FooterJoin'

export default {
  components: { IntegrationCard, TextSearchInput, FooterJoin },
  mixins: [cmsPage],
  layout: 'saas',
  data() {
    return {
      searchQuery: '',
      selectedFilters: new Set(),
      categories: {},
    }
  },
  computed: {
    formattedTitle() {
      const md = MarkdownIt({ html: false, breaks: false })
      return md.renderInline(this.page.intro_title)
    },
    filteredIntegrations() {
      const regex = new RegExp('(' + escapeRegExp(this.searchQuery) + ')', 'i')
      const hasAnyFilter = Object.keys(this.categories).some((category) => {
        return Object.keys(this.categories[category]).some((type) => {
          return this.categories[category][type]
        })
      })
      return this.page.integrations.filter((integration) => {
        const matchSearch =
          !this.searchQuery || integration.value.name.match(regex)
        const matchCategory =
          !hasAnyFilter ||
          this.categories[integration.value.category][integration.value.type]
        return matchSearch && matchCategory
      })
    },
  },
  created() {
    this.page.integrations.forEach((integration) => {
      const category = integration.value.category
      const type = integration.value.type
      if (!Object.prototype.hasOwnProperty.call(this.categories, category)) {
        this.categories[category] = {}
      }
      if (
        !Object.prototype.hasOwnProperty.call(this.categories[category], type)
      ) {
        this.categories[category][type] = false
      }
    })
  },
  methods: {
    setCategoryType(category, type, value) {
      const categories = clone(this.categories)
      categories[category][type] = value
      this.categories = categories
    },
  },
}
</script>
